import { Delete } from "@mui/icons-material"
import { IconButton, Tooltip } from "@mui/material"
import { useEffect, useState } from "react";

export default function AddRaterGroups({formik}) {
    const [error, setError] = useState('');
    const [errorNoOfRaters, setErrorNoOfRaters] = useState('');

    useEffect(() => {      
        delete formik.errors.raterGroups     
    }, [])

    useEffect(() => {        
        formik.submitForm()
    }, [formik.values.raterGroups])

    const removeGroupName = (index) => {
        let updatedGroupNames = [...formik.values.raterGroups];
        updatedGroupNames.splice(index, 1);
        // setGroupNames(updatedGroupNames)
        formik.setFieldValue('raterGroups', updatedGroupNames);
    };

    function checkGroupName(name, array){
        for (let i=0; i < array.length; i++) {
            if (array[i].name === name) {
                return true;
            }
        }
    }

    const normalizeString = (value) => {
        if (!value) return '';
        return value.trim().replace(/\s+/g, ' ');
    };

    const addRaterGroup = () => {
        console.log("formik.values.raterGroupName",formik.values.raterGroupName)
        const raterGroupName = normalizeString(formik.values.raterGroupName);
        if(raterGroupName === ''){
            setError('Group Name is required')
        }
        if(formik.values.raterGroupRaters <= 0){
            setErrorNoOfRaters('No. of raters should be greater than 0')
        }
        if(formik.values.raterGroupRaters === ''){
            setErrorNoOfRaters('No. of raters is required')
        }
        // if(formik.values.raterGroupName !== '' && formik.values.raterGroupRaters > 0){
        if(raterGroupName !== ''){
            setError('')
            setErrorNoOfRaters('')
            if(checkGroupName(raterGroupName, formik.values.raterGroups)){
                setError('Group Name is already added')
            }
            else{
                formik.setFieldValue('raterGroups', [...formik.values.raterGroups, {id: 0, name: raterGroupName, noOfRaters: formik.values.raterGroupRaters,min_one_rater: 0}]);
                formik.setFieldValue('raterGroupName', '');
                formik.setFieldValue('raterGroupRaters', '');
            }   
            
        }       
    }

    const handleGroupNameChange = (e) => {
        let value = e.target.value
        formik.setFieldValue('raterGroupName', value);
        setError('')
    }

    const handleMinOneRaterChange = (index, checked) => {

        let groups = [...formik.values.raterGroups];

        groups[index].min_one_rater = checked ? 1 : 0;

        // if (checked && groups[index].noOfRaters < 1) {
        //     groups[index].noOfRaters = 1;
        // }

        formik.setFieldValue('raterGroups', groups);
    };

    return (
        <div className="row py-4">
            <div className="col-md-6 offset-md-3 mt-4">
                <h3 className="heading fs_20">Add Rater Groups</h3>
                {formik.values.raterGroups.length < 6 && (
                    <div className="row mb-3">
                        <label className="form-label">Rater Group</label>
                        <div className="col-md-10">
                            <div className="input-group input-group-merge">
                                <span className="input-group-text">
                                    <i className="bx bxs-group"></i>
                                </span>
                                <input type="text" className="form-control" placeholder="Group Name" name="raterGroupName" 
                                    onChange={handleGroupNameChange}
                                    onBlur={handleGroupNameChange}
                                    value={formik.values.raterGroupName}
                                />
                            </div>
                            {error && error !== '' && (
                                <div className="text-danger">{error}</div>
                            )}
                        </div>
                        {/* <div className="col-md-5">
                            <div className="input-group input-group-merge">
                                <span id="basic-icon-default-name" className="input-group-text"><i className="bx bxs-group"></i></span>
                                <input type="number" min="1" className="form-control" id="basic-icon-default-name" placeholder="No. of Rater(s)" aria-label="No. of Rater(s)" aria-describedby="basic-icon-default-fullname2" name="raterGroupRaters"
                                    onChange={handleNoOfRatersChange} 
                                    onBlur={handleNoOfRatersChange}
                                    value={formik.values.raterGroupRaters}
                                />
                            </div>
                            {errorNoOfRaters && errorNoOfRaters !== '' && (
                                <div className="text-danger">{errorNoOfRaters}</div>
                            )}
                        </div> */}
                        <div className="col-md-2 mt-1">
                            <button onClick={addRaterGroup} className="btn btn-primary">Add</button>
                        </div>
                    </div>
                )}
            </div>
            {/* <hr/> */}
            <div className="col-md-6 offset-md-3">
                <div className="row">
                <table className="table table-striped mb-3">
                    <thead>
                        <tr>
                            <th scope="col">S. No.</th>
                            <th scope="col">Group Name</th>
                            <th scope="col">Min 1 Rater</th>
                            <th scope="col">Action</th>  
                        </tr>
                    </thead>
                    <tbody>
                        {formik.values.raterGroups.map((raterGroup, index) => (
                            <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>{raterGroup.name}</td>
                                {/* <td>{raterGroup.noOfRaters}</td> */}
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={raterGroup.min_one_rater == 1}
                                        onChange={(e)=>handleMinOneRaterChange(index,e.target.checked)}
                                    />
                                </td>
                                <td>
                                    {
                                        raterGroup?.id && raterGroup.id > 0 ?
                                        '' : 
                                        <Tooltip title="Delete" size='small' className='icon icon-sm icon-primary'>
                                            <IconButton
                                                onClick={() => removeGroupName(index)}
                                            >
                                                <Delete/>
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </td>                                               
                            </tr>
                        ))}
                    </tbody>
                </table>
                </div>
                {formik.errors.raterGroups && formik.errors.raterGroups !== '' ? <div className="text-danger">{formik.errors.raterGroups}</div> : ''}
            </div>
            
            
        </div>
    )
}